'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { ThemeCard } from '@/components/themes/ThemeCard';
import { THEMES } from '@sizzlenz/shared';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
export function ExploreThemesSection() {
  const $ = _c(4);
  if (!THEMES.length) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-3xl font-bold text-gray-900">Themes</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-between mb-8">{t0}<Link href="/themes" className="text-sm font-medium text-blue-600 hover:text-blue-700 flex items-center gap-1 cursor-pointer">View all <ArrowRight className="w-4 h-4" /></Link></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "start",
      loop: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="py-16"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t1}<Carousel opts={t2} className="w-full"><CarouselContent className="-ml-4">{THEMES.map(_temp)}</CarouselContent><CarouselPrevious className="left-0 -translate-x-1/2" /><CarouselNext className="right-0 translate-x-1/2" /></Carousel></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(theme) {
  return <CarouselItem key={theme.slug} className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3"><ThemeCard {...theme} /></CarouselItem>;
}